

export default {
    computed: {
        //订单状态
        getOrderStatus() {
            return [
                {
                    value: '0',
                    label: '草稿'
                },
                {
                    value: '70',
                    label: '已确认',
                    theme:'success',
                },
                {
                    value: '90',
                    label: '已取消',
                    theme:'error',
                }
            ]
        },
        //关联单据类型
        getRelativeOrderTypes() {
            return [
                // { value: 15, label: '中转入库计划' },
                // { value: 25, label: '中转出库计划' },
                // { value: 20, label: '中转出库单' },
                // { value: 10, label: '中转入库单' },
                { value: 110, label: "中转计划" },
                { value: 115, label: "中转入库单" },
                { value: 120, label: "中转出库单" },
                { value: 50, label: '销售出库计划单' },
                { value: 80, label: '调拨计划单' },
                { value: 60, label: '调拨出库单' },
                { value: 70, label: '调拨入库单' },
                { value: 40, label: '销售退货单' },
                { value: 45, label: '销售退货计划单' },
                { value: 35, label: '入库计划单' },
                { value: 30, label: '入库单' },
                { value: 100, label: '卡车预约单' },
                { value: 130, label: '订单包裹异动单'}
            ]
        },
    },
}
